module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Attract",
    on: {
      "click": _vm.showHideSelector
    }
  }, [(_vm.animal.messages) ? _c('messages', {
    ref: "messages",
    staticClass: "Attract-messages",
    attrs: {
      "content": _vm.animal.messages,
      "alt-colors": _vm.selectorIsActive
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "Attract-selector-"
    }
  }, [(_vm.animals.length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectorIsActive),
      expression: "selectorIsActive"
    }],
    staticClass: "Attract-selector"
  }, [_c('p', {
    staticClass: "Attract-selectorMessage"
  }, [_vm._v("Touch to Select, Swipe for More.")]), _vm._v(" "), _c('carousel', {
    ref: "carousel",
    staticClass: "Attract-selectorCarousel",
    attrs: {
      "initial-index": _vm.$route.params.animalIndex - 1,
      "next": _vm.goNext,
      "prev": _vm.goPrev
    }
  }, _vm._l((_vm.animals), function(animal, index) {
    return _c('div', {
      ref: "animals",
      refInFor: true,
      staticClass: "Attract-selectorCarouselItem",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openOrSelect(index)
        }
      }
    }, [_c('div', {
      staticClass: "Attract-selectorCarouselItemContent"
    }, [(!animal.available) ? _c('status-badge', {
      staticClass: "Attract-selectorCarouselItemStatusBadge"
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "Attract-selectorCarouselItemImage",
      attrs: {
        "src": animal.image
      }
    })], 1)])
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "Attract-arrows-"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSliding),
      expression: "!isSliding"
    }],
    staticClass: "Attract-arrows"
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLeftArrow),
      expression: "showLeftArrow"
    }],
    staticClass: "Attract-arrowLeft",
    attrs: {
      "name": "arrow-triple-left",
      "width": "49px",
      "height": "24.46px"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRightArrow),
      expression: "showRightArrow"
    }],
    staticClass: "Attract-arrowRight",
    attrs: {
      "name": "arrow-triple-right",
      "width": "49px",
      "height": "24.46px"
    }
  })], 1)])], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "Attract-image-"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.selectorIsActive),
      expression: "!selectorIsActive"
    }],
    staticClass: "Attract-image"
  }, [(!_vm.animal.available) ? _c('status-badge', {
    staticClass: "Attract-statusBadge"
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "Attract-imageImage-",
      "mode": "in-out"
    }
  }, [(_vm.animal.image) ? _c('img', {
    key: _vm.animal.id,
    staticClass: "Attract-imageImage",
    attrs: {
      "src": _vm.animal.image
    }
  }) : _vm._e()])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-327b3f7e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Attract.vue
// module id = 357
// module chunks = 1